import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, isObservable, of, share, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetsCachedHttpClientService {

  private readonly cache = new Map<string, HttpResponse<Blob> | Observable<HttpResponse<Blob>>>()

  constructor(private readonly httpClinet: HttpClient) {
    console.log('ctor assetCache')
  }

  get(url: string): Observable<HttpResponse<Blob>> {
    if (this.cache.has(url)) {
      const cachedResponse = this.cache.get(url)!
      if (isObservable(cachedResponse)) return cachedResponse as Observable<HttpResponse<Blob>>
      else return of(cachedResponse as HttpResponse<Blob>)
    }
    else {
      const response$ = this.httpClinet.get(url, { observe: 'response', responseType: 'blob' }).pipe(share())

      this.cache.set(url, response$)
      response$.subscribe(response => this.cache.set(url, response))

      return response$
    }

  }
}
